import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Users } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const VisitorCounter = () => {
  const { language } = useLanguage();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const trackAndFetch = async () => {
      try {
        // Generate or get visitor ID
        let visitorId = localStorage.getItem('uae-visitor-id');
        if (!visitorId) {
          visitorId = `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          localStorage.setItem('uae-visitor-id', visitorId);
        }

        // Track this visitor
        const formData = new FormData();
        formData.append('visitor_id', visitorId);
        await axios.post(`${API}/visitors/track`, formData);

        // Get total count
        const response = await axios.get(`${API}/visitors/count`);
        setCount(response.data.count);
      } catch (error) {
        console.error('Error tracking visitor:', error);
      } finally {
        setLoading(false);
      }
    };

    trackAndFetch();
  }, []);

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  return (
    <div 
      className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20"
      data-testid="visitor-counter"
    >
      <Users className="w-4 h-4 text-[#CE1126]" />
      <span className="text-white text-sm font-medium">
        {loading ? (
          <span className="animate-pulse">...</span>
        ) : (
          <>
            <span className="text-[#009639] font-bold">{formatNumber(count)}</span>
            {' '}
            <span className="text-white/80">
              {language === 'ar' ? 'زائر' : 'visitors'}
            </span>
          </>
        )}
      </span>
    </div>
  );
};
